import React, { useState, useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Pyramid from './pyramid/Pyramid';

export default function About() {
    const { t } = useTranslation();

    return (
        <Box
            component="section"
            id="structure"
            sx={{
                py: { xs: 8, sm: 12, md: 16 },
                backgroundColor: '#FFFFFF',
            }}
        >
            <Container maxWidth="lg">
                {/* Section Header */}
                <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 600,
                            color: '#1D1D1F',
                            fontSize: {
                                xs: '2.25rem',
                                sm: '2.75rem',
                                md: '3.25rem',
                            },
                            lineHeight: 1.1,
                            letterSpacing: '-0.02em',
                            mb: 2,
                        }}
                    >
                        {t("pyramid.headerTitle")}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: '#86868B',
                            fontSize: '1.25rem',
                            maxWidth: '600px',
                            mx: 'auto',
                        }}
                    >
                        {t("pyramid.headerSubtitle")}
                    </Typography>
                </Box>

                {/* Pyramid Component */}
                <Pyramid />
            </Container>
        </Box>
    );
}